module.exports = __webpack_public_path__ + "static/media/trigon.04e3821e.png";